import { useState } from 'react'
import { useUserSettings } from 'src/Hooks'

interface ReturnType {
  saveLegendState: () => Promise<void>
  hideLegend: boolean
}

/**
 * Provides the ability to save the state of the legend for a chart.
 */
export const useLegendState = (chartLayoutId: string): ReturnType => {
  const { userSettings, updateUserSettings } = useUserSettings()

  const updateChartIdList = (chartIDs: string[], id: string): string[] => {
    const index = chartIDs.indexOf(id)
    if (index !== -1) {
      chartIDs.splice(index, 1)
      return chartIDs
    }
    return [...chartIDs, id]
  }

  const parseHideChartLegend = (hideChartLegend: string | undefined): string[] => {
    if (!hideChartLegend) return []
    try {
      const parsed = JSON.parse(hideChartLegend)
      return Array.isArray(parsed) ? parsed : []
    } catch (e) {
      console.error('Failed to parse hideChartLegend:', e)
      return []
    }
  }

  const chartIdsWithHiddenLegend = parseHideChartLegend(userSettings?.hideChartLegend)

  const isChartLegendHidden = (chartIdList: string[], customLayoutId: string): boolean => {
    return chartIdList.includes(customLayoutId)
  }

  const hideLegend = isChartLegendHidden(chartIdsWithHiddenLegend, `${chartLayoutId}`)
  const [isLegendHidden, setIsLegendHidden] = useState(hideLegend)

  const saveLegendState = async (): Promise<void> => {
    setIsLegendHidden(prev => !prev)

    const filteredChartIDs = updateChartIdList(chartIdsWithHiddenLegend, chartLayoutId)
    await updateUserSettings({ hideChartLegend: JSON.stringify(filteredChartIDs) })
  }

  return { saveLegendState, hideLegend: isLegendHidden }
}
